import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  NgModule,
  SimpleChanges,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from "@angular/core";
import { OnboardingService } from "../../shared/service/onboarding.service";
import { OnboardingHRDetail } from "../../shared/models/OnboardingHRDetail";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { DatePipe, CommonModule } from "@angular/common";
import { AppConfig } from "../../app.config";
import { UserService } from "../../shared/service/user.service";
import { DepartmentsService } from "../../shared/service/departments.service";
import { CadreService } from "../../shared/service/cadre.service";
import { EmployeeService } from "../../shared/service/employee.service";
import {
  BasicEmployeeDetails,
  HistoryDetails,
} from "../../shared/models/basicemployeedetails.model";
import { isUndefined, isNullOrUndefined } from "util";
import { usaStatesList } from "../../../Models/UsaMasterStatesList";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import * as _moment from "moment";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  AbstractControl,
  Validators,
  ValidationErrors,
} from "@angular/forms";
import {
  DesignationDialog,
  DesignationDialogComponent,
} from "../../shared/components/designation-dialog/designation-dialog.component";
import { MatDialog, MatDatepickerInputEvent } from "@angular/material";
import {
  TechGroupDialog,
  TechgroupDialogComponent,
} from "../../shared/components/techgroup-dialog/techgroup-dialog.component";
import {
  ExpDialog,
  ExpertiseDialogComponent,
} from "../../shared/components/expertise-dialog/expertise-dialog.component";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { PeopleManagersHistoryDetails } from "../../shared/models/PeopleManagersHistoryDetails";
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import { HREmployeeDetails } from "../../shared/models/hremployeecommunicationdetails.model";
import { File_Types } from "../../shared/UploadFileTypes";
import { FileUploadService } from "../../shared/service/fileUpload.service";
import { SeniorManagersHistoryDetails } from "../../shared/models/SeniorManagersHistoryDetails";
import { EmployeeLocationHistories } from "../../shared/models/EmployeeLocationHistories";
import { EmployeeDesignationHistories } from "../../shared/models/EmployeeDesignationHistories";
import { EmployeeDepartmentHistories } from "../../shared/models/EmployeeDepartmentHistories";
import { EmployeeCadreHistories } from "../../shared/models/EmployeeCadreHistories";
import { empty, from } from "rxjs";
import {
  DepartmentDialog,
  DepartmentDialogComponent,
} from "../../shared/components/department-dialog/department-dialog.component";
import {
  CadreDialog,
  CadreDialogComponent,
} from "../../shared/components/cadre-dialog/cadre-dialog.component";
import { ExitInterviews } from "../../shared/models/ExitInterviews";
import { exit } from "process";
import { StatusDialogComponent } from "../../shared/components/status-dialog/status-dialog.component";
import { EmployeeEmailHistories } from "../../shared/models/EmployeeEmailHistories";

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

type TeamListCallback = (teamList: any[]) => void;

@Component({
  selector: "app-hr-history",
  templateUrl: "./hr-history.component.html",
  styleUrls: ["./hr-history.component.scss"],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
@NgModule({
  imports: [CommonModule],
})
export class HrHistoryComponent implements OnInit, OnChanges {
  displayedColumns: string[] = [
    "View",
    "ResignationDate",
    "IndicativeLWD",
    "LastWorkingDate",
    "ResignationType",
    "ResignationReason",
    "status",
    "ModifiedDate",
    "Attachment",
  ];
  ResignationHSTableRowsData: ResignationHSTableInterface[] = [];

  showDivision: boolean = false;
  error: string;
  date: Date;
  HREmp: BasicEmployeeDetails;
  HREm: HistoryDetails;
  newAttribute: any = {};
  newAttributepm: any = {};
  newAttributeDes: any = {};
  newAttributeLoc: any = {};
  newAttributeMail: any = {};
  isLoader: boolean = false;
  newAttributeDep: any = {};
  newAttributeCad: any = {};
  IsExpand = false;
  HrDetailsForm: FormGroup;
  submitted = false;
  exception = false;
  designationsList: any;
  locationsList: any;
  departmentsList: any;
  cadresList: any;
  employeeType: string;
  datePipe: DatePipe;
  MAX_SIZE: number = 1048576;
  EmpDetform: FormGroup;
  @Output("employeeDet") employeeDet = new EventEmitter();
  @Input() empCode: any;
  @Output("HrEmpOutput") HrEmpOutput = new EventEmitter();
  @Output("HistoryOutput") HistoryOutput = new EventEmitter();
  @Output() dateChange: EventEmitter<MatDatepickerInputEvent<any>>;
  @ViewChild("jobLocationStateInput", { static: false })
  @ViewChild("paginator", { static: false })
  paginator: MatPaginator;
  jobLocationStateInput: ElementRef<HTMLInputElement>;
  empList: any[];
  UserRolesList: any[];
  //@Input() hide: boolean;
  //@Input() required: boolean
  @Input() isProfile: boolean;
  filteredList: any[] = [];
  filteredPMList: any;
  filteredSMList: any;
  filteredCadreList: any[] = [];
  filteredLocationsList: any;
  tempPMList: pmObj[] = [];
  tempSMList: smObj[] = [];
  designationId: any;
  departmentId: any;
  cadreId: any;
  filteredDeptList: any[] = [];
  todayDate: Date;
  maxDate: Date;
  currentYear: any;
  currentMonth: any;
  currentDate: any;
  Required: boolean = false;
  RequiredTech: boolean = false;
  RequiredDept: boolean = false;
  RequiredCadre: boolean = false;
  teamList: any;
  eeTypeList: any;
  techGroupList: any;
  expertiseList: any;
  TechGroupId: any;
  filteredTechList: any;
  HistoryList: any;
  defaultLocation: boolean = false;
  usaStates: any = {};
  @Output("filteredExpList") filteredExpList: any;
  enableJoblocationState: boolean;
  expertiseId: any;
  astricbool: boolean = false;
  RequiredExp: boolean = false;
  result: any;
  LoginEmpCode: any;
  employeeDetails: HREmployeeDetails;
  originalHrEmp: BasicEmployeeDetails;
  EmpId: any;
  disableforMyProfile: boolean;
  approveCheckMyProfile: any;
  isNoDataFound: boolean = false;
  disableDOE: boolean;
  resignationDetails: [];
  ResponseList: any;
  HRCommentsList: any;
  divisionsList = [
    { ID: 36, DivisionName: "Delivery" },
    { ID: 37, DivisionName: "Non-Delivery" },
  ];

  selectedExpertiseIds: any[] = [];
  originalHistoryDetails: any;
  dataSource: MatTableDataSource<ResignationHSTableInterface>;
  HRcomments: any;
  QuestionList: any;
  SubmitList: any;
  exitInterviews: ExitInterviews;
  isAccordion: boolean = false;
  isAcc: boolean = false;
  ResList: any;
  isSubmitVisible: boolean = false;
  isCommentsDisabled: boolean = false;
  isLWD = true;
  exitInterviewsList: any;
  showAddButton: boolean = true;
  hasAddPermission = false
  emailPattern = "[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@[winwire]+(.[com]+)*";


  constructor(
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private userService: UserService,
    public router: Router,
    private hrSvc: OnboardingService,
    public toastr: ToastrService,
    public file_Svc: FileUploadService,
    private cadreSvc: CadreService,
    private deptSvc: DepartmentsService,
    private emp_Svc: EmployeeService,
    public dialog: MatDialog
  ) {
    this.todayDate = new Date();
    this.currentYear = new Date().getFullYear();
    this.currentMonth = new Date().getMonth();
    this.currentDate = new Date().getDate();
    this.maxDate = new Date(
      this.currentYear + 1,
      this.currentMonth,
      this.currentDate
    );
    this.route.params.subscribe((params) => {
      this.empCode = params["empCode"];
      this.initializeParamChange();
    });
  }
  initializeParamChange() {
    this.route.params.subscribe((params) => {
      this.empCode = params["empCode"];
    });

    //get the login employee code
    this.LoginEmpCode = this.userService.getEmpCode().toString();
    this.EmpId = this.LoginEmpCode;
    if (!isNullOrUndefined(this.empCode)) {
      if (this.router.url.startsWith("/myprofile/")) {
        if (this.empCode === this.LoginEmpCode) this.isProfile = true;
        else this.router.navigate(["/EmployeeWithoutPermission"]);
      }
    }
    //this.getEmpHistory();
  }

  checkPermission() {
    var permission = this.userService.userInfo.permissions.find(
      (i) => i.Menu === "Master"
    );
    this.hasAddPermission = permission != null ? permission.AddingPermission || permission.HasFullAccess : false;
  }

  ngOnInit() {
    this.usaStates = usaStatesList;
    this.getOffboardingHistoryFun();
    this.checkPermission();
    this.getSubmitMyProfileData();
    //this.getCommunicationData();
    //this.getDesignations();
    //this.GetTechGroup();
    //this.FormInitialization();
    //this.getLocations();
    //this.getDepartments();
    //this.getCadres();
    //this.getEmployeeList();
    //this.getEmployeeSMList();
    //this.getUserRoles();
    //this.getTeams();
    // this.getEeType();
    // this.getBasicEmployeeByCode();
    this.getEmpHistory();
    this.onLoadJobLocations();
    this.getExitInterviewResponses();
    setTimeout(() => {
      this.isLoader = false;
    }, 1000);
    this.exitInterviews = new ExitInterviews();
    this.getExitInterviewHRComments();

  }

  getRefreshPage() {
    window.location.reload();
  }

  isEmailValid(email: string) {
    const emailRegex = new RegExp(this.emailPattern);
    return email && emailRegex.test(email);
  }

  onEmailBlur(email: string, index: number): void {
    const isValid = this.isEmailValid(email);
    this.HREm.employeeEmailHistories[index].isInvalidEmail = !isValid;
  }


  GetHistory() {
    //this.onSelectedTechGroupId();

    this.getEmployeeList();
    this.getEmployeeSMList();

    const hasErrors = this.checkForDuplicateNames();
    const filterDes = [];
    for (let i = 0; i < this.HREm.employeeDesignationHistories.length; i++) {
      const currentDes = this.HREm.employeeDesignationHistories[i];
      const filterData = this.filteredList.find(
        (item) => item.DesignationName === currentDes.DesignationName
      );

      if (filterData) {
        // Only update DesignationId if it is different from the current one
        if (currentDes.DesignationId !== filterData.ID) {
          const eachItem = { ...currentDes, DesignationId: filterData.ID };
          filterDes.push(eachItem);
        } else {
          filterDes.push(currentDes);
        }
      } else {
        filterDes.push(currentDes);
      }
    }
    this.HREm.employeeDesignationHistories = filterDes;

    const filterDep = [];
    for (let i = 0; i < this.HREm.employeeDepartmentHistories.length; i++) {
      const currentDep = this.HREm.employeeDepartmentHistories[i];
      const filterData = this.filteredDeptList.find(
        (item) => item != null && currentDep != null && item.DepartmentName === currentDep.DepartmentName
      );
      if (filterData) {
        // Only update DesignationId if it is different from the current one
        if (currentDep.DepartmentId !== filterData.ID) {
          const eachItem = { ...currentDep, DepartmentId: filterData.ID };
          filterDep.push(eachItem);
        } else {
          filterDep.push(currentDep);
        }
      } else {
        filterDep.push(currentDep);
      }
    }
    this.HREm.employeeDepartmentHistories = filterDep;
    //let filterDe = []
    //if (!isNullOrUndefined(this.HREm.employeeDepartmentHistories)) {
    //  for (let i = 0; i < this.HREm.employeeDepartmentHistories.length; i++) {
    //    const filtered = this.filteredTechList.find((item) => item.GroupName === this.HREm.employeeDepartmentHistories[i].TechGroupName)
    //    if (filtered) {
    //      const eachItem = { ...this.HREm.employeeDepartmentHistories[i], TechGroupId: filtered.ID }
    //      filterDe.push(eachItem)
    //    }
    //  }

    //}

    //this.HREm.employeeDepartmentHistories = filterDe

    // this.HREm.employeeDepartmentHistories = filterDe;

    const filterCadre = [];
    for (let i = 0; i < this.HREm.employeeCadreHistories.length; i++) {
      const currentCadre = this.HREm.employeeCadreHistories[i];
      const filterData = this.filteredCadreList.find(
        (item) => item.CadreName === currentCadre.CadreName
      );

      if (filterData) {
        if (currentCadre.CadreId !== filterData.ID) {
          const eachItem = { ...currentCadre, CadreId: filterData.ID };
          filterCadre.push(eachItem);
        } else {
          filterCadre.push(currentCadre);
        }
      } else {
        filterCadre.push(currentCadre);
      }
    }

    this.HREm.employeeCadreHistories = filterCadre;

    this.HREm.peopleManagersHistoryDetails.forEach((item) => {
      item.CreatedBy = this.LoginEmpCode;
      item.EmpCode = this.empCode;
      item.UpdatedBy = this.LoginEmpCode;
    });

    this.HREm.seniorManagersHistoryDetails.forEach((item) => {
      item.CreatedBy = this.LoginEmpCode;
      item.EmpCode = this.empCode;
      item.UpdatedBy = this.LoginEmpCode;
    });

    this.HREm.employeeDepartmentHistories.forEach((item) => {
      item.CreatedBy = this.LoginEmpCode;
      item.EmpCode = this.empCode;
      item.ModifiedBy = this.LoginEmpCode;
    });

    this.HREm.employeeCadreHistories.forEach((item) => {
      item.CreatedBy = this.LoginEmpCode;
      item.EmpCode = this.empCode;
      item.ModifiedBy = this.LoginEmpCode;
    });

    this.HREm.employeeDesignationHistories.forEach((item) => {
      item.CreatedBy = this.LoginEmpCode;
      item.EmpCode = this.empCode;
      item.ModifiedBy = this.LoginEmpCode;
    });

    this.HREm.employeeLocationHistories.forEach((item) => {
      item.CreatedBy = this.LoginEmpCode;
      item.EmpCode = this.empCode;
      item.ModifiedBy = this.LoginEmpCode;
    });

    this.HREm.employeeEmailHistories.forEach((item) => {
      item.CreatedBy = this.LoginEmpCode;
      item.EmpCode = this.empCode;
      item.ModifiedBy = this.LoginEmpCode;
    });

    this.HREm.hasErrorss = hasErrors;
    this.HREm.ExitInterviewHRComments =
      this.exitInterviewsList && this.exitInterviewsList.ExitInterviewHRComments;
    this.HREm.EmpCode = this.empCode;
    this.HistoryOutput.emit(this.HREm);
  }

  isValid(): { isValid: boolean; errorMessages: string[] } {
    let isValid = true;
    let errorMessages = [];

    if (!isNullOrUndefined(this.HREm.seniorManagersHistoryDetails)) {
      this.HREm.seniorManagersHistoryDetails.forEach((obj) => {
        if (isNullOrUndefined(obj.smDisplayName)) {
          isValid = false;
          errorMessages.push("Senior Manager Name is required");
        }
      });
    }

    if (!isNullOrUndefined(this.HREm.peopleManagersHistoryDetails)) {
      this.HREm.peopleManagersHistoryDetails.forEach((obj) => {
        if (isNullOrUndefined(obj.pmDisplayName)) {
          isValid = false;
          errorMessages.push("People Manager Name is required");
        }
      });
    }

    if (!isNullOrUndefined(this.HREm.employeeDesignationHistories)) {
      this.HREm.employeeDesignationHistories.forEach((obj) => {
        if (isNullOrUndefined(obj.DesignationName)) {
          isValid = false;
          errorMessages.push("Designation is required");
        }
      });
    }

    if (!isNullOrUndefined(this.HREm.employeeDepartmentHistories)) {
      this.HREm.employeeDepartmentHistories.forEach((obj) => {
        if (isNullOrUndefined(obj.DepartmentName)) {
          isValid = false;
          errorMessages.push("Department is required");
        }
      });
    }

    if (
      this.HREm.employeeLocationHistories &&
      this.HREm.employeeLocationHistories.length > 0
    ) {
      for (let i = 0; i < this.HREm.employeeLocationHistories.length; i++) {
        const obj = this.HREm.employeeLocationHistories[i];
        if (
          isNullOrUndefined(obj.JobLocationState) ||
          obj.JobLocationState.trim() === ""
        ) {
          isValid = false;
          errorMessages.push(`Location is required`);
          break;
        }
      }
    }

    if (!isNullOrUndefined(this.HREm.employeeCadreHistories)) {
      this.HREm.employeeCadreHistories.forEach((obj) => {
        if (isNullOrUndefined(obj.CadreName)) {
          isValid = false;
          errorMessages.push("Cadre is required");
        }
      });
    }
    return { isValid, errorMessages };
  }

  ngOnChanges(changes: SimpleChanges) {
    this.employeeDetails = new HREmployeeDetails();
    this.HREmp = new BasicEmployeeDetails();
    this.HREm = new HistoryDetails();
    if (isNullOrUndefined(this.empCode)) {
      this.HrEmpOutput.emit(this.HREmp);
      this.newAttribute = {};
      this.HREm.seniorManagersHistoryDetails.push(this.newAttribute);
      this.newAttributepm = {};
      this.HREm.peopleManagersHistoryDetails.push(this.newAttributepm);
      this.newAttributeDes = {};
      this.HREm.employeeDesignationHistories.push(this.newAttributeDes);
      this.newAttributeLoc = {};
      this.HREm.employeeLocationHistories.push(this.newAttributeLoc);
      this.newAttributeDep = {};
      this.HREm.employeeDepartmentHistories.push(this.newAttributeDep);
      this.newAttributeCad = {};
      this.HREm.employeeCadreHistories.push(this.newAttributeCad);
      this.HistoryOutput.emit(this.HREm);
    }
    this.getEmployeeList();
    this.getCommunicationData();
    this.getDesignations();
    //this.GetTechGroup();
    this.FormInitialization();
    //this.getLocations();
    this.getDepartments();
    this.getCadres();
    this.getUserRoles();
    this.getTeams();

    this.getBasicEmployeeByCode();
    this.getEmpHistory();
    //this.getEmployeeSMList();
    //this.getEeType();
  }

  ngDoCheck() {
    this.checkForDuplicateNames();
  }

  private requireMatchSM(index, control: FormControl): ValidationErrors | null {
    const selectedSM: any = control.value;
    let match = null;
    if (
      !isNullOrUndefined(selectedSM) &&
      selectedSM != ""
    ) {
      if (!isNullOrUndefined(this.filteredSMList)) {
        for (var i = 0; i < this.filteredSMList.length; i++) {
          if (this.filteredSMList[i].recDisplayName == selectedSM) {
            match = null;
            break;
          } else {
            match = true;
          }
        }
        if (match == true) {
          this.HREm.seniorManagersHistoryDetails[index].InvalidName = match;
          return { requireMatchApproverID: match };
        }
        else {
          this.HREm.seniorManagersHistoryDetails[index].InvalidName = false;
        }
      }
    } else {
      this.HREm.seniorManagersHistoryDetails[index].InvalidName = false;
      return null;
    }
  }

  private requireMatchPM(index, control: FormControl): ValidationErrors | null {
    const selectedPM: any = control.value;
    let match = null;
    if (
      !isNullOrUndefined(selectedPM) &&
      selectedPM != ""
    ) {
      if (!isNullOrUndefined(this.filteredPMList)) {
        for (var i = 0; i < this.filteredPMList.length; i++) {
          if (this.filteredPMList[i].recDisplayName == selectedPM) {
            match = null;
            break;
          } else {
            match = true;
          }
        }
        if (match == true) {
          this.HREm.peopleManagersHistoryDetails[index].InvalidName = match;
          return { requireMatchApproverID: match };
        }
        else {
          this.HREm.peopleManagersHistoryDetails[index].InvalidName = false;
        }
      }
    } else {
      this.HREm.peopleManagersHistoryDetails[index].InvalidName = false;
      return null;
    }
  }

  checkForDuplicateNames(): boolean {
    let hasErrors = false;

    for (let i = 1; i < this.HREm.seniorManagersHistoryDetails.length; i++) {
      const currentManager = this.HREm.seniorManagersHistoryDetails[i];
      const previousManager = this.HREm.seniorManagersHistoryDetails[i - 1];

      // Reset the error state first
      currentManager.hasDuplicateNameError = false;
      currentManager.duplicateNameMessage = "";

      if (currentManager.smDisplayName === previousManager.smDisplayName) {
        currentManager.hasDuplicateNameError = true;
        currentManager.duplicateNameMessage =
          "Senior Manager cannot remain the same as previous record.";
        hasErrors = true;
      }
    }

    for (let i = 1; i < this.HREm.peopleManagersHistoryDetails.length; i++) {
      const currentManager = this.HREm.peopleManagersHistoryDetails[i];
      const previousManager = this.HREm.peopleManagersHistoryDetails[i - 1];

      currentManager.hasDuplicateNameError = false;
      currentManager.duplicateNameMessage = "";

      if (currentManager.pmDisplayName === previousManager.pmDisplayName) {
        currentManager.hasDuplicateNameError = true;
        this.HREmp.Duplicates = true;
        currentManager.duplicateNameMessage =
          "People Manager cannot remain the same as previous record.";
        hasErrors = true;
      }
    }

    for (let i = 1; i < this.HREm.employeeDesignationHistories.length; i++) {
      const currentDes = this.HREm.employeeDesignationHistories[i];
      const previousDes = this.HREm.employeeDesignationHistories[i - 1];

      currentDes.hasDuplicateNameError = false;
      currentDes.duplicateNameMessage = "";

      if (currentDes.DesignationName === previousDes.DesignationName) {
        currentDes.hasDuplicateNameError = true;
        currentDes.duplicateNameMessage =
          "Designation cannot remain the same as previous record.";
        hasErrors = true;
      }
    }

    for (let i = 1; i < this.HREm.employeeCadreHistories.length; i++) {
      const currentCad = this.HREm.employeeCadreHistories[i];
      const previousCad = this.HREm.employeeCadreHistories[i - 1];

      currentCad.hasDuplicateNameError = false;
      currentCad.duplicateNameMessage = "";

      if (currentCad.CadreName === previousCad.CadreName) {
        currentCad.hasDuplicateNameError = true;
        currentCad.duplicateNameMessage =
          "Cadre cannot remain the same as previous record";
        hasErrors = true;
      }
    }

    for (let i = 1; i < this.HREm.employeeEmailHistories.length; i++) {
      const currentMail = this.HREm.employeeEmailHistories[i];
      const previousMail = this.HREm.employeeEmailHistories[i - 1];

      currentMail.hasDuplicateNameError = false;
      previousMail.duplicateNameMessage = "";

      currentMail.InvalidMail = false;
      previousMail.InvalidMailMessage = "";

      if (currentMail.Email === previousMail.Email) {
        currentMail.hasDuplicateNameError = true;
        currentMail.duplicateNameMessage =
          "Email cannot remain the same as previous record";
        hasErrors = true;
      }
      else if (currentMail.isInvalidEmail) {
        currentMail.InvalidMail = true;
        currentMail.InvalidMailMessage =
          "Ex: user@winwire.com";
        hasErrors = true;
      }
    }


    for (let i = 1; i < this.HREm.employeeDepartmentHistories.length; i++) {
      const currentDep = this.HREm.employeeDepartmentHistories[i];
      const previousDep = this.HREm.employeeDepartmentHistories[i - 1];

      currentDep.hasDuplicateNameError = false;
      currentDep.duplicateNameMessage = "";

      if (currentDep.DepartmentName === previousDep.DepartmentName) {
        currentDep.hasDuplicateNameError = true;
        currentDep.duplicateNameMessage =
          "Department cannot remain the same as previous record.";
        hasErrors = true;
      }
    }

    this.HREm.employeeLocationHistories.forEach((location) => {
      location.hasDuplicateNameError = false;
      location.duplicateNameMessage = "";
    });
    for (let i = 1; i < this.HREm.employeeLocationHistories.length; i++) {
      const currentLocation = this.HREm.employeeLocationHistories[i];
      const previousLocation = this.HREm.employeeLocationHistories[i - 1];
      //currentLocation.hasDuplicateNameError = false;
      //currentLocation.duplicateNameMessage = '';

      if (
        currentLocation.JobLocationState === previousLocation.JobLocationState
      ) {
        currentLocation.hasDuplicateNameError = true;
        currentLocation.duplicateNameMessage =
          "Job location state cannot remain the same as previous record";
        hasErrors = true;
      }
      this.cdr.detectChanges();
    }
    return hasErrors;
  }

  getEmpHistory() {
    this.isLoader = true;
    this.emp_Svc.getEmployeeHistory(this.empCode).subscribe(
      (data: any) => {
        this.HREm = data;
        this.getEmployeeList();
        this.HREm.employeeDepartmentHistories.map((item: any) => {
          if (this.departmentsList != null) {
            const dep = this.departmentsList.find(
              (dep: any) => dep.ID === item.DepartmentId
            );
            if (dep) {
              item.DepartmentName = dep.DepartmentName;
            }
          }
        });

        //if (this.HREm.seniorManagersHistoryDetails.length == 0) {
        //  this.newAttribute = {
        //    ID: 0,
        //    DurationFrom: "",
        //    DurationTo: "",
        //    Name: "",
        //    Designation: "",
        //  };
        //  this.HREm.seniorManagersHistoryDetails.push(this.newAttribute);
        //  this.newAttribute = {};
        //}

        //if (this.HREm.peopleManagersHistoryDetails.length == 0) {
        //  this.newAttribute = {
        //    ID: 0,
        //    DurationFrom: "",
        //    DurationTo: "",
        //    Name: "",
        //    Designation: "",
        //  };
        //  this.HREm.peopleManagersHistoryDetails.push(this.newAttribute);
        //  this.newAttributepm = {};
        //}

        if (
          this.HREm.employeeDepartmentHistories != null &&
          this.HREm.employeeDepartmentHistories.length > 0
        ) {
          for (
            var i = 0;
            i < this.HREm.employeeDepartmentHistories.length;
            i++
          ) {
            if (
              this.HREm.employeeDepartmentHistories[i].DepartmentName != null
            ) {
              this.doFilterDept(
                this.HREm.employeeDepartmentHistories[i].DepartmentName,
                i
              );
            }
          }
        }

        //this.HREm.employeeDepartmentHistories!.map((item: any) => {
        //  const techGroup = this.techGroupList.find((techGroupItem) => techGroupItem.ID == item.TechGroupId);
        //  if (techGroup) {
        //    item.TechGroupName = techGroup.GroupName;
        //  }

        //  if (this.expertiseList && this.expertiseList.length > 0) {
        //    const ids = item.ExpertiseId.split(',');
        //    const expertiseNames = ids.map((id) => {
        //      const expertise = this.expertiseList.find((expertiseItem) => expertiseItem.ID === Number(id));
        //      return expertise ? expertise.Value : null;
        //    });
        //    item.ExpertiseName = expertiseNames.filter((name) => name !== null).join(', ');
        //  }
        //});

        var seniorManager = new SeniorManagersHistoryDetails();
        this.HREm = data;
        var peopleManager = new PeopleManagersHistoryDetails();

        this.HREm.employeeDesignationHistories.forEach((item: any) => {
          if (this.designationsList != null) {
            const designation = this.designationsList.find(
              (des: any) => des.ID === item.DesignationId
            );
            if (designation) {
              item.DesignationName = designation.DesignationName;
            }
          }
        });

        if (
          this.HREm.employeeDesignationHistories != null &&
          this.HREm.employeeDesignationHistories.length > 0
        ) {
          for (
            var i = 0;
            i < this.HREm.employeeDesignationHistories.length;
            i++
          ) {
            if (
              this.HREm.employeeDesignationHistories[i].DesignationName != null
            ) {
              this.doFilter(
                this.HREm.employeeDesignationHistories[i].DesignationName,
                i
              );
            }
          }
        }

        this.HREm.employeeLocationHistories.forEach((item: any) => {
          if (this.locationsList != null) {
            const location = this.locationsList.find(
              (loc: any) => loc.ID === item.LocationId
            );
            if (location) {
              item.LocationID = location.ID;
              if (item.LocationID === 1 || item.LocationID === 2) {
                this.setJobLocationState(item);
              }
            }
          }
        });
        this.HREm.employeeCadreHistories.forEach((item: any) => {
          if (this.divisionsList != null) {
            const div = this.divisionsList.find(
              (div: any) => div.ID === item.DivisionId
            );
            if (div) {
              item.Div = div.DivisionName;
            }
          }
        });

        this.HREm.employeeCadreHistories.forEach((item: any) => {
          if (this.cadresList != null) {
            const cadre = this.cadresList.find(
              (cad: any) => cad.ID === item.CadreId
            );
            if (cadre) {
              item.CadreName = cadre.CadreName;
            }
          }
        });

        if (
          this.HREm.employeeCadreHistories != null &&
          this.HREm.employeeCadreHistories.length > 0
        ) {
          for (var i = 0; i < this.HREm.employeeCadreHistories.length; i++) {
            if (this.HREm.employeeCadreHistories[i].CadreName != null) {
              this.doFilterCadre(
                this.HREm.employeeCadreHistories[i].CadreName,
                i
              );
            }
          }
        }
        this.getEmployeeSMList();

        this.getLocations();
        this.originalHistoryDetails = JSON.parse(JSON.stringify(this.HREm));
        this.HistoryOutput.emit(this.HREm);

        setTimeout(() => {
          this.isLoader = false;
        }, 2000);
      },
      (error) => (this.error = error)
    );
  }

  getSubmitMyProfileData() {
    this.emp_Svc
      .GetProfileVerificationStatus(this.LoginEmpCode)
      .subscribe((data: any) => {
        this.approveCheckMyProfile = data;
        if (this.isProfile == true) {
          for (var i = 0; i < data.length; i++) {
            this.disableforMyProfile = data[i].Submitted;
          }
        }
      });
  }
  getTeams() {
    this.deptSvc.getMasterGroupByCategory("Team").subscribe((data: any) => {
      this.deptSvc
        .getMasterGroupByGroupID(data[0].ID)
        .subscribe((dataList: any) => {
          this.teamList = dataList;
        });
    });
  }









  //getEeType() {
  //  this.deptSvc.getMasterGroupByCategory("EeType").subscribe((data: any) => {
  //    this.deptSvc
  //      .getMasterGroupByGroupID(data[0].ID)
  //      .subscribe((dataList: any) => {
  //        this.eeTypeList = dataList;
  //      });
  //  });
  //}
  //GetTechGroup() {
  //  this.deptSvc
  //    .getMasterGroupByCategory("TechGroup")
  //    .subscribe((data: any) => {
  //      this.RequiredTech = true;
  //      this.techGroupList = data;
  //      this.filteredTechList = this.techGroupList;
  //    });
  //}

  //onSelectedTechGroupId() {
  //  if (this.HREmp.TechGroupId != null) {
  //    this.deptSvc
  //      .getMasterGroupByGroupID(this.HREmp.TechGroupId)
  //      .subscribe((dataList: any) => {
  //        this.RequiredExp = true;
  //        this.expertiseList = dataList;
  //        this.expertiseList.forEach((item) => {
  //          if (item.ID == this.HREmp.ExpertiseId) {
  //            this.expertiseId = item.Value;
  //          }
  //        });
  //        this.filteredExpList = this.expertiseList;
  //      });

  //  }
  //}

  getDesignations() {
    this.hrSvc.getDesignations().subscribe((data: any) => {
      this.Required = true;
      this.designationsList = data;
      this.filteredList[0] =
        this.filteredList.length > 0 && this.filteredList[0].length > 0
          ? this.filteredList[0]
          : this.designationsList;
      // if (!isUndefined(this.empCode)) {
      // this.getBasicEmployeeByCode();
      //}
    });
  }
  getLocations() {
    this.hrSvc.getLocations().subscribe((data: any) => {
      this.locationsList = data;
    });
  }
  getDepartments() {
    this.hrSvc.getDepartments().subscribe((data: any) => {
      this.RequiredDept = true;
      this.departmentsList = data;
      this.filteredDeptList[0] =
        this.filteredDeptList.length > 0 && this.filteredDeptList[0].length > 0
          ? this.filteredDeptList[0]
          : this.departmentsList;
    });
  }
  getCadres() {
    this.hrSvc.getCadres().subscribe((data: any) => {
      this.RequiredCadre = true;
      this.cadresList = data;
      this.filteredCadreList[0] =
        this.filteredCadreList.length > 0 &&
          this.filteredCadreList[0].length > 0
          ? this.filteredCadreList[0]
          : this.cadresList;
    });
  }

  getEmployeeList() {
    this.isLoader = true;
    this.emp_Svc.getEmployeeBasicDetails().subscribe(
      (data: any[]) => {
        this.tempPMList = [];
        this.empList = data;
        this.empList.forEach((el) => {
          let item = new pmObj();
          item.pmDisplayName = el.FirstName + " - " + el.EmpCode;
          item.pmEmpCode = el.EmpCode;
          this.tempPMList.push(item);
        });
        //this.filteredPMList = this.tempPMList;
        this.filteredPMList = this.tempPMList.filter(
          (emp) => emp.pmEmpCode !== this.HREmp.EmpCode
        );
        //this.HREmp.peopleManagersHistoryDetails.forEach((el) => {
        //  console.log("===el===", el)
        //  if (Object.keys(el).length > 0) {
        //    el.pmDisplayName = this.tempPMList.filter(
        //      (x) => x.pmEmpCode === el.ManagerCode
        //    )[0].pmDisplayName;
        //  }
        //});
        if (this.HREm.peopleManagersHistoryDetails) {
          this.HREm.peopleManagersHistoryDetails!.map((el) => {
            if (Object.keys(el).length > 0) {
              el.pmDisplayName =
                this.tempPMList.filter(
                  (x) => x.pmEmpCode === el.ManagerCode
                )[0] != null
                  ? this.tempPMList.filter(
                    (x) => x.pmEmpCode === el.ManagerCode
                  )[0]!.pmDisplayName
                  : null;
            }
          });
          setTimeout(() => {
            this.isLoader = false;
          }, 800);
        }
      },
      (error) => {
        this.isLoader = false;
        this.error = error;
      }
    );
  }
  getUserRoles() {
    this.emp_Svc.getUserRoles().subscribe(
      (data: any[]) => {
        this.UserRolesList = data;
      },
      (error) => (this.error = error)
    );
  }
  getEmployeeSMList() {
    this.isLoader = true;
    if (this.empList != null) {

      this.tempSMList = [];

      this.empList.forEach((el) => {
        let item = new smObj();
        item.smDisplayName = el.FirstName + " - " + el.EmpCode;
        item.smEmpCode = el.EmpCode;
        this.tempSMList.push(item);
      });
      //this.filteredSMList = this.tempSMList;
      this.filteredSMList = this.tempSMList.filter(
        (emp) => emp.smEmpCode !== this.HREmp.EmpCode
      );
      this.HREm.seniorManagersHistoryDetails.forEach((el) => {
        el.smDisplayName =
          this.tempSMList.filter(
            (x) => x.smEmpCode === el.SeniorManagerCode
          )[0] != null
            ? this.tempSMList.filter(
              (x) => x.smEmpCode === el.SeniorManagerCode
            )[0]!.smDisplayName
            : null;
      })
    }
    else {
      this.emp_Svc.getEmployeeBasicDetails().subscribe(
        (data: any[]) => {
          this.tempSMList = [];
          this.empList = data;
          this.empList.forEach((el) => {
            let item = new smObj();
            item.smDisplayName = el.FirstName + " - " + el.EmpCode;
            item.smEmpCode = el.EmpCode;
            this.tempSMList.push(item);
          });
          //this.filteredSMList = this.tempSMList;
          this.filteredSMList = this.tempSMList.filter(
            (emp) => emp.smEmpCode !== this.HREmp.EmpCode
          );
          this.HREm.seniorManagersHistoryDetails.forEach((el) => {
            el.smDisplayName =
              this.tempSMList.filter(
                (x) => x.smEmpCode === el.SeniorManagerCode
              )[0] != null
                ? this.tempSMList.filter(
                  (x) => x.smEmpCode === el.SeniorManagerCode
                )[0]!.smDisplayName
                : null;
          });
          setTimeout(() => {
            this.isLoader = false;
          }, 800);
        },
        (error) => {
          this.isLoader = false;




          this.error = error;
        }
      );
    }

  }

  getTeamList(callback: TeamListCallback) {
    this.deptSvc.getMasterGroupByCategory("Team").subscribe((data: any) => {
      this.deptSvc
        .getMasterGroupByGroupID(data[0].ID)
        .subscribe((dataList: any[]) => {
          this.teamList = dataList;
          callback(this.teamList); // Invoke the callback with teamList
        });
    });
  }

  getBasicEmployeeByCode() {
    this.emp_Svc.getBasicEmployeeById(this.empCode).subscribe(
      (data: any) => {
        this.HrDetailsForm.get("EmployeeCode").disable();
        this.HrDetailsForm.get("OfficeMailId").disable();
        this.HREmp = data;
        this.getEmployeeList();
        if (this.HREmp.LocationID == 1 || this.HREmp.LocationID == 2) {
          this.disableDOE = true;
        } else this.disableDOE = false;
        if (!this.HREmp.CelebratedDOB) {
          this.HREmp.CelebratedDOB = this.HREmp.DOB;
        }
        this.designationsList.forEach((item) => {
          if (item.ID == this.HREmp.DesignationId) {
            this.designationId = item.DesignationName;
          }
        });
        this.departmentsList.forEach((item) => {
          if (item.ID == this.HREmp.DepartmentId) {
            this.departmentId = item.DepartmentName;
          }
        });
        this.cadresList.forEach((item) => {
          if (item.ID == this.HREmp.CadreId) {
            this.cadreId = item.CadreName;
          }
        });
        //this.techGroupList.forEach((item) => {
        //  if (item.ID == this.HREmp.TechGroupId) {
        //    this.TechGroupId = item.GroupName;
        //  }
        //});
        this.getEmployeeSMList();

        this.getLocations();
        //this.onSelectedTechGroupId();
        this.HREmp.ExpertiseId = data.ExpertiseId.split(",");
        this.getCommunicationData();
        this.HrEmpOutput.emit(this.HREmp);
        //this.HistoryOutput.emit(this.HREm);
      },
      (error) => (this.error = error)
    );
  }

  onLoadJobLocations() {
    this.hrSvc.getLocations().subscribe((data: any) => {
      this.locationsList = data;
    });
  }

  setJobLocationState(location: any) {
    if (location.LocationID === 1) {
      location.JobLocationState = "Telangana";
    } else if (location.LocationID === 2) {
      location.JobLocationState = "Karnataka";
    } else {
      location.JobLocationState = "";
    }
    this.checkForDuplicateNames();
    //jobLocationStateInput.value = location.JobLocationState;
  }

  setCadre(cad: any) {
    cad.CadreName = "";
    if (cad.DivisionId != null) {
      var Id = cad.DivisionId == 36 ? true : false;
      this.hrSvc.getCadres().subscribe((data: any) => {
        this.cadresList = data;
        this.filteredCadreList = this.cadresList.filter(
          (item) => item.IsDelivery == Id
        );
      });
    }
  }

  FormInitialization() {
    this.EmpDetform = new FormGroup({
      PAN: new FormControl(),
      Aadhar: new FormControl(),
      PanFile: new FormControl(),
      AadharFile: new FormControl(),
    });
    this.HrDetailsForm = new FormGroup({
      EmployeeCode: new FormControl(),
      OfficeMailId: new FormControl("", [
        Validators.required,
        Validators.pattern(
          "[a-zA-Z0-9!#$%&amp;'*+/=?^_`{|}~.-]+@[winwire]+(.[com]+)*"
        ),
      ]),
      SecondaryEmail: new FormControl("", [
        Validators.email,
        this.emailDomain,
        Validators.pattern(
          "[a-zA-Z0-9!#$%&amp;'*+/=?^_`{|}~.-]+@[a-zA-Z]+(.[a-z]+)*"
        ),
      ]),
      DOJ: new FormControl(),
      DateOfExit: new FormControl(),
      MobileNo: new FormControl(),
      FirstName: new FormControl(),
      LastName: new FormControl(),
      MiddleName: new FormControl(),
      NamePerRecords: new FormControl(),
      DOB: new FormControl(),
      CelebratedDOB: new FormControl(),
      Gender: new FormControl(),
      BloodGroup: new FormControl(),
      Designation: new FormControl("", [
        Validators.required,
        this.requireMatch.bind(this),
      ]),
      Location: new FormControl(),
      JobLocationState: new FormControl(),
      ConsultantType: new FormControl(),
      PeopleManager: new FormControl(),
      SeniorManager: new FormControl(),
      Cadre: new FormControl("", [
        Validators.required,
        this.requireMatchCadre.bind(this),
      ]),
      EeTypeId: new FormControl(),
      TeamId: new FormControl(),
      TimeZone: new FormControl(),
      MCPId: new FormControl(),
      DivisionId: new FormControl(),
      //TechGroupId: new FormControl(), //'', [Validators.required]),
      //ExpertiseId: new FormControl(), //'', [Validators.required]),
      Department: new FormControl("", [
        Validators.required,
        this.requireMatchDept.bind(this),
      ]),
      Title: new FormControl(),
    });
  }
  ChangeDesignation() {
    const message = `Add New Designation`;
    const dialogData = new DesignationDialog("Action", message);
    const dialogRef = this.dialog.open(DesignationDialogComponent, {
      width: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.getDesignations();
          this.filteredList.filter((x) => x.Id == dialogResult.DesignationName);
          this.designationId = "";
          this.Required = false;
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }
  ChangeDepartment() {
    const message = `Add New Department`;
    const dialogData = new DepartmentDialog("Action", message);
    const dialogRef = this.dialog.open(DepartmentDialogComponent, {
      width: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.getDepartments();
          this.filteredDeptList.filter(
            (x) => x.Id == dialogResult.DepartmentName
          );
          this.departmentId = "";
          this.RequiredDept = false;
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }
  ChangeCadre() {
    const message = `Add New Cadre`;
    const dialogData = new CadreDialog("Action", message);
    const dialogRef = this.dialog.open(CadreDialogComponent, {
      width: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.getCadres();
          this.filteredCadreList.filter((x) => x.Id == dialogResult.CadreName);
          this.cadreId = "";
          this.RequiredCadre = false;
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  getObjectState() {
    const originalHistoryDetailsTemp = this.originalHistoryDetails;
    let customthHREm = this.HREm;
    const newArr = this.HREm["peopleManagersHistoryDetails"].map((item) => {
      let temp: Partial<PeopleManagersHistoryDetails> = {};
      for (const obj in item) {
        if (
          obj !== "pmDisplayName" &&
          obj !== "duplicateNameMessage" &&
          obj !== "hasDuplicateNameError"
        ) {
          temp = { ...temp, [obj]: item[obj] };
        }
      }
      return temp as PeopleManagersHistoryDetails;
    });

    const seniorManArr = this.HREm["seniorManagersHistoryDetails"].map(
      (item) => {
        let tem: Partial<SeniorManagersHistoryDetails> = {};
        for (const obj in item) {
          if (
            obj !== "smDisplayName" &&
            obj !== "duplicateNameMessage" &&
            obj !== "hasDuplicateNameError"
          ) {
            tem = { ...tem, [obj]: item[obj] };
          }
        }
        return tem as SeniorManagersHistoryDetails;
      }
    );

    const DesArr = this.HREm["employeeDesignationHistories"].map((item) => {
      let te: Partial<EmployeeDesignationHistories> = {};
      for (const obj in item) {
        if (obj !== "duplicateNameMessage" && obj !== "hasDuplicateNameError") {
          te = { ...te, [obj]: item[obj] };
        }
      }
      return te as EmployeeDesignationHistories;
    });

    const DepArr = this.HREm["employeeDepartmentHistories"].map((item) => {
      let dep: Partial<EmployeeDepartmentHistories> = {};
      for (const obj in item) {
        if (obj !== "duplicateNameMessage" && obj !== "hasDuplicateNameError") {
          dep = { ...dep, [obj]: item[obj] };
        }
      }
      return dep as EmployeeDepartmentHistories;
    });

    const LocArr = this.HREm["employeeLocationHistories"].map((item) => {
      let loc: Partial<EmployeeLocationHistories> = {};
      for (const obj in item) {
        if (obj !== "duplicateNameMessage" && obj !== "hasDuplicateNameError") {
          loc = { ...loc, [obj]: item[obj] };
        }
      }
      return loc as EmployeeLocationHistories;
    });

    const CadArr = this.HREm["employeeCadreHistories"].map((item) => {
      let cad: Partial<EmployeeCadreHistories> = {};
      for (const obj in item) {
        if (obj !== "duplicateNameMessage" && obj !== "hasDuplicateNameError") {
          cad = { ...cad, [obj]: item[obj] };
        }
      }
      return cad as EmployeeCadreHistories;
    });

    customthHREm = {
      ...customthHREm,
      peopleManagersHistoryDetails: newArr,
      seniorManagersHistoryDetails: seniorManArr,
      employeeDesignationHistories: DesArr,
      employeeDepartmentHistories: DepArr,
      employeeLocationHistories: LocArr,
      employeeCadreHistories: CadArr,
    };
    const currentHistoryDetailsTemp = JSON.parse(JSON.stringify(customthHREm));

    var historyDetailsVal =
      JSON.stringify(originalHistoryDetailsTemp) ===
      JSON.stringify(currentHistoryDetailsTemp);
    return !historyDetailsVal;
  }




  openDialog(offboardingID: number): void {
    this.emp_Svc.getOffboardingHistoryApi(this.empCode).subscribe(
      (data: any) => {
        data = data.filter(({ status }) =>
          [
            "Submitted",
            "Approved",
            "Confirmed",
            "Rejected by HR",
            "Rejected(HR)",
            "Rejected by Manager",
            "Rejected(Manager)",
            "Revoked",
            "Completed",
          ].includes(status)
        );
        const group = data.filter(item => item.OffboardingID === offboardingID);
        if (group.length > 1) {
          const remainingRecords = group;
          const dialogRef = this.dialog.open(StatusDialogComponent, {
            width: '61%',
            data: remainingRecords,
          });
          dialogRef.afterClosed().subscribe(result => {
            //console.log('Dialog was closed');
          });
        }
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }


  getOffboardingHistoryFun() {
    this.emp_Svc.getOffboardingHistoryApi(this.empCode).subscribe(
      (data: any) => {
        data = data.filter(({ status }) =>
          [
            "Submitted",
            "Approved",
            "Confirmed",
            "Rejected by HR",
            "Rejected(HR)",
            "Rejected by Manager",
            "Rejected(Manager)",
            "Revoked",
            "Completed",
          ].includes(status)
        );

        const groupedData = this.groupByOffboardingID(data);

        groupedData.forEach(group => {
          group.sort((a, b) => {
            const dateA = new Date(a.ResignationDate).getTime();
            const dateB = new Date(b.ResignationDate).getTime();
            return dateB - dateA;
          });
        });

        data = groupedData.map(group => {
          group.sort((a, b) => {
            const dateA = new Date(a.ModifiedDate).getTime();
            const dateB = new Date(b.ModifiedDate).getTime();
            return dateB - dateA;
          });
          const latestRecord = group[0];
          const recordCount = group.length;
          return {
            ...latestRecord,
            showAddButton: recordCount > 1
          };
        });
        this.ResignationHSTableRowsData = data;
        this.dataSource = new MatTableDataSource<ResignationHSTableInterface>(this.ResignationHSTableRowsData);
        this.dataSource.paginator = this.paginator;
        this.isNoDataFound = data && data.length === 0;
      },
      (error) => (this.error = error)
    );
  }

  groupByOffboardingID(data: ResignationHSTableInterface[]): ResignationHSTableInterface[][] {
    return data.reduce((groups, item) => {
      const group = groups.find(group => group[0].OffboardingID === item.OffboardingID);
      if (group) {
        group.push(item);
      } else {
        groups.push([item]);
      }
      return groups;
    }, []);
  }

  //getOffboardingHistoryFun() {
  //  this.emp_Svc.getOffboardingHistoryApi(this.empCode).subscribe(
  //    (data: any) => {
  //      data = data.filter(({ status }) =>
  //        [
  //          "Submitted",
  //          "Approved",
  //          "Confirmed",
  //          "Rejected by HR",
  //          "Rejected(HR)",
  //          "Rejected by Manager",
  //          "Rejected(Manager)",
  //          "Revoked",
  //          //"Revoked by Employee",
  //          //"Revoked(Employee)",
  //          //"Revoked by HR",
  //          //"Revoked(HR)",
  //          //"Revoked by Manager",
  //          //"Revoked(Manager)",
  //          "Completed",
  //        ].includes(status)
  //      );
  //      data.sort((a, b) => {
  //        const dateA = new Date(a.ResignationDate).getTime();
  //        const dateB = new Date(b.ResignationDate).getTime();
  //        return dateA - dateB;
  //      });

  //      data = data.map((item) => {
  //        return {
  //          ...item,
  //          // ResignationDate:
  //          //   item.ResignationDate &&
  //          //   new Date(item.ResignationDate).toISOString().split("T")[0],
  //          // IndicativeLWD:
  //          //   item.IndicativeLWD &&
  //          //   new Date(item.IndicativeLWD).toISOString().split("T")[0],
  //          // LastWorkingDate:
  //          //   item.LastWorkingDate &&
  //          //   new Date(item.LastWorkingDate).toISOString().split("T")[0],
  //          // ModifiedDate:
  //          //   item.ModifiedDate &&
  //          //   new Date(item.ModifiedDate).toISOString().split("T")[0],
  //        };
  //      });

  //      this.ResignationHSTableRowsData = data;
  //      this.dataSource = new MatTableDataSource<ResignationHSTableInterface>(
  //        this.ResignationHSTableRowsData
  //      );
  //      this.dataSource.paginator = this.paginator;
  //      if (data && data.length === 0) {
  //        this.isNoDataFound = true;
  //      } else {
  //        this.isNoDataFound = false;
  //        this.dataSource.paginator = this.paginator;
  //      }
  //    },
  //    (error) => (this.error = error)
  //  );
  //}

  getCommunicationData() {
    this.emp_Svc.getEmployeeDetails(this.empCode).subscribe(
      (data: any) => {
        this.employeeDetails = data;

        this.employeeDet.emit(this.employeeDetails);
      },
      (error) => (this.error = error)
    );
  }
  emptydate() {
    this.HrDetailsForm.get("DateOfExit").reset();
  }
  emptyTodate(index) {
    //this.HrDetailsForm.get('DurationTo').reset();
    this.HREm.peopleManagersHistoryDetails[index].DurationTo = null;
  }




















  //ChangeTechGroup() {
  //  const message = `Add New Tech Group`;
  //  const dialogDataTech = new TechGroupDialog("Action", message);
  //  const dialogRefTech = this.dialog.open(TechgroupDialogComponent, {
  //    width: "400px",
  //    data: dialogDataTech,
  //  });
  //  dialogRefTech.afterClosed().subscribe(
  //    (dialogResultTech) => {
  //      if (dialogResultTech) {
  //        this.GetTechGroup();
  //        this.TechGroupId = dialogResultTech.GroupName;
  //        this.RequiredTech = false;
  //      }
  //    },
  //    (error) => {
  //      this.error = error;
  //    }
  //  );
  //}
  //ChangeExpertise() {
  //  const message = `Add New Expertise`;
  //  var techgrouplist = this.techGroupList;
  //  const dialogDataExp = new ExpDialog("Action", message, techgrouplist, null, null, null);
  //  const dialogRefExp = this.dialog.open(ExpertiseDialogComponent, {
  //    width: "400px",
  //    data: dialogDataExp,
  //  });
  //  dialogRefExp.afterClosed().subscribe(
  //    (dialogResultExp) => {
  //      if (dialogResultExp) {
  //        this.GetTechGroup();
  //        this.onSelectedTechGroupId();
  //        this.expertiseId = dialogResultExp.Value;
  //        this.RequiredExp = false;
  //      }
  //    },
  //    (error) => {
  //      this.error = error;
  //    }
  //  );
  //}

  doFilter(value: string, index) {
    if (value && value.trim().length > 0) {
      this.filteredList[index] = this.designationsList
        .filter((desg) =>
          desg.DesignationName.toLowerCase().includes(value.toLowerCase())
        )
        .map((desg) => ({
          ...desg,
          DesignationName: desg.DesignationName,
          DesignationId: desg.ID,
        }));
    } else {
      // Reset the filtered list to the full designations list if no filter is applied
      this.filteredList[index] = this.designationsList.map((desg) => ({
        ...desg,
        DesignationName: desg.DesignationName,
        DesignationId: desg.ID,
      }));
    }
  }

  doFilterCadre(value: string, index) {
    if (value && value.trim().length > 0) {
      // Filter the designations based on the input value
      this.filteredCadreList[index] = this.cadresList
        .filter((cad) =>
          cad.CadreName.toLowerCase().includes(value.toLowerCase())
        )
        .map((cad) => ({
          ...cad,
          CadreName: cad.CadreName,
          CadreId: cad.ID,
        }));
    } else {
      this.filteredCadreList[index] = this.cadresList.map((cad) => ({
        ...cad,
        CadreName: cad.CadreName,
        CadreId: cad.ID,
      }));
    }
  }

  doFilterDept(value: string, index) {
    if (value && value.trim().length > 0) {
      // Filter the designations based on the input value
      this.filteredDeptList[index] = this.departmentsList
        .filter((dep) =>
          dep.DepartmentName.toLowerCase().includes(value.toLowerCase())
        )
        .map((dep) => ({
          ...dep,
          DepartmentName: dep.DepartmentName,
          DepartmentId: dep.ID,
        }));
    } else {
      this.filteredDeptList[index] = this.departmentsList.map((dep) => ({
        ...dep,
        DepartmentName: dep.DepartmentName,
        DepartmentId: dep.ID,
      }));
    }
  }

  //doFilterCadre() {
  //  if (!isNullOrUndefined(this.cadreId)) {
  //    this.filteredCadreList = this.filterCadre(this.cadresList);
  //  }
  //}

  //doFilterTech() {
  //  if (!isNullOrUndefined(this.TechGroupId)) {
  //    this.filteredTechList = this.filterTech(this.techGroupList);

  //  }
  //}
  doPMFilter(pm) {
    if (!isNullOrUndefined(pm)) {
      this.filteredPMList = this.filterPM(this.tempPMList, pm).filter(
        (emp) => emp.pmEmpCode !== this.HREmp.EmpCode
      );
    }
  }
  doSMFilter(sm) {
    if (!isNullOrUndefined(sm)) {
      this.filteredSMList = this.filterSM(this.tempSMList, sm).filter(
        (emp) => emp.smEmpCode !== this.HREmp.EmpCode
      );
    }
  }
  equals(objOne, objTwo) {
    if (typeof objOne !== "undefined" && typeof objTwo !== "undefined") {
      return objOne.id === objTwo.id;
    }
  }
  changeClient(data) {
    alert("selected --->" + data);
  }



















  //onExp(event) {
  //  if (event.option.value == "") {
  //    this.ChangeExpertise();
  //  } else {
  //    this.HREmp.ExpertiseId = event.option.id;
  //    this.onSelectedTechGroupId();
  //  }
  //}
  //addExp() {
  //  this.ChangeExpertise();
  //}
  //onTech(event) {
  //  if (event.option.value == "") {
  //    this.ChangeTechGroup();
  //  } else {
  //    this.HREmp.TechGroupId = event.option.id;
  //    this.onSelectedTechGroupId();
  //  }
  //}
  onDept(event) {
    if (event == "Delivery") {
      this.astricbool = true;
    } else {
      this.astricbool = false;
    }
  }
  onSelectionChanged(event, desgn, index) {
    if (event.option.value === "") {
      this.ChangeDesignation();
    } else {
      const updatedDesignation = {
        ...this.HREm.employeeDesignationHistories[index],
        DesignationName: event.option.value,
        DesignationId: event.option.id,
      };
      this.HREm.employeeDesignationHistories[index] = updatedDesignation;
    }
  }

  onCadreSelectionChanged(event, cad, index) {
    if (event.option.value === "") {
      this.ChangeCadre();
    } else {
      const updatedCadre = {
        ...this.HREm.employeeCadreHistories[index],
        CadreName: event.option.value,
        CadreId: event.option.id,
      };
      this.HREm.employeeCadreHistories[index] = updatedCadre;
    }
  }

  onDeptSelectionChanged(event, dep, index) {
    if (event.option.value === "") {
      this.ChangeDepartment();
    } else {
      const updatedDep = {
        ...this.HREm.employeeDepartmentHistories[index],
        DepartmentName: event.option.value,
        DepartmentId: event.option.id,
      };
      this.HREm.employeeDepartmentHistories[index] = updatedDep;
    }
  }

  //onDeptSelectionChanged(event) {
  //  if (event.option.value == "") {
  //    this.ChangeDepartment();
  //  } else {
  //    this.HREmp.DepartmentId = event.option.id;
  //  }
  //}

  filter(values) {
    return values.filter((value) =>
      value.DesignationName.toLowerCase().includes(
        this.designationId.toLowerCase()
      )
    );
  }
  filterDept(values) {
    return values.filter((value) =>
      value.DepartmentName.toLowerCase().includes(
        this.departmentId.toLowerCase()
      )
    );
  }
  filterCadre(values) {
    return values.filter((value) =>
      value.CadreName.toLowerCase().includes(this.cadreId.toLowerCase())
    );
  }
  filterTech(values) {
    return values.filter((value) =>
      value.GroupName.toLowerCase().includes(this.TechGroupId.toLowerCase())
    );
  }
  //filterExp(values) {
  //  return values.filter((value) =>
  //    value.Value.toLowerCase().includes(this.expertiseId.toLowerCase())
  //  );
  //}
  //filterPM(values, pm) {
  //  return values.filter((value) =>
  //    value!.pmDisplayName!.toLowerCase().includes(pm!.toLowerCase())
  //  );
  //}
  filterPM(values, pm) {
    return values.filter((value) =>
      value!
        .pmDisplayName!.toLowerCase()
        .includes(typeof pm === "string" ? pm.toLowerCase() : "")
    );
  }
  //filterSM(values, sm) {
  //  return values.filter((value) =>
  //    value!.smDisplayName!.toLowerCase().includes(sm!.toLowerCase())
  //  );
  //}

  filterSM(values, sm) {
    return values.filter((value) =>
      value!
        .smDisplayName!.toLowerCase()
        .includes(typeof sm === "string" ? sm.toLowerCase() : "")
    );
  }
  //Custom validation for Designation(Mat autocomplete) to validate user text with designations list
  //Returns true if user text is not found in designation list
  private requireMatch(control: FormControl): ValidationErrors | null {
    const selection: any = control.value;
    let match = null;
    if (!isNullOrUndefined(selection) && selection != "") {
      if (this.Required == true) {
        if (!isNullOrUndefined(this.designationsList)) {
          for (var i = 0; i < this.designationsList.length; i++) {
            if (this.designationsList[i].DesignationName == selection) {
              match = null;
              break;
            } else {
              match = true;
            }
          }
          if (match == true) {
            return { requireMatch: match };
          }
        }
      }
    } else {
      return null;
    }
  }

  //Custom validation for Department(Mat autocomplete) to validate user text with departnents list
  //Returns true if user text is not found in department list
  private requireMatchDept(control: FormControl): ValidationErrors | null {
    const selectionDept: any = control.value;
    let match = null;
    if (!isNullOrUndefined(selectionDept) && selectionDept != "") {
      if (this.RequiredDept == true) {
        if (!isNullOrUndefined(this.departmentsList)) {
          for (var i = 0; i < this.departmentsList.length; i++) {
            if (this.departmentsList[i].DepartmentName == selectionDept) {
              match = null;
              break;
            } else {
              match = true;
            }
          }
          if (match == true) {
            return { requireMatchDept: match };
          }
        }
      }
    } else {
      return null;
    }
  }

  private requireMatchCadre(control: FormControl): ValidationErrors | null {
    const selectionCadre: any = control.value;
    let match = null;
    if (!isNullOrUndefined(selectionCadre) && selectionCadre != "") {
      if (this.RequiredCadre == true) {
        if (!isNullOrUndefined(this.cadresList)) {
          for (var i = 0; i < this.cadresList.length; i++) {
            if (this.cadresList[i].CadreName == selectionCadre) {
              match = null;
              break;
            } else {
              match = true;
            }
          }
          if (match == true) {
            return { requireMatchCadre: match };
          }
        }
      }
    } else {
      return null;
    }
  }

  //Custom validation for Techgroup(Mat autocomplete) to validate user text with techgroup list
  //Returns true if user text is not found in techgroup list
  private requireMatchTech(control: FormControl): ValidationErrors | null {
    const selectionTech: any = control.value;
    let match = null;
    if (!isNullOrUndefined(selectionTech) && selectionTech != "") {
      if (this.RequiredTech == true) {
        if (!isNullOrUndefined(this.techGroupList)) {
          for (var i = 0; i < this.techGroupList.length; i++) {
            if (this.techGroupList[i].GroupName == selectionTech) {
              match = null;
              break;
            } else {
              match = true;
            }
          }
          if (match == true) {
            return { requireMatchTech: match };
          }
        }
      }
    } else {
      return null;
    }
  }

  //Custom validation for Techgroup(Mat autocomplete) to validate user text with techgroup list
  //Returns true if user text is not found in techgroup list
  private requireMatchExp(control: FormControl): ValidationErrors | null {
    const selectionExp: any = control.value;
    let match = null;
    if (!isNullOrUndefined(selectionExp) && selectionExp != "") {
      if (this.RequiredExp == true) {
        if (!isNullOrUndefined(this.expertiseList)) {
          for (var i = 0; i < this.expertiseList.length; i++) {
            if (this.expertiseList[i].Value == selectionExp) {
              match = null;
              break;
            } else {
              match = true;
            }
          }
          if (match == true) {
            return { requireMatchExp: match };
          }
        }
      }
    } else {
      return null;
    }
  }
  emailDomain(control: AbstractControl): { [key: string]: any } | null {
    if (control.value != null) {
      const SecondaryEmail: string = control.value;
      const domain = SecondaryEmail.substring(
        SecondaryEmail.lastIndexOf("@") + 1
      );
      if (SecondaryEmail === "" || domain.toLowerCase() === "winwire.com") {
        return { emailDomain: true };
      } else {
        return null;
      }
    }
  }

  someMethodName(fromDateofJoining: Date, j) {
    var todate = new Date(fromDateofJoining);
    const fromYear = todate.getFullYear();
    const fromMonth = todate.getMonth();
    const fromDate = todate.getDate();
    if (this.HREm.peopleManagersHistoryDetails[j + 1]) {
      this.HREm.peopleManagersHistoryDetails[j + 1].DurationFrom = new Date(
        fromYear,
        fromMonth,
        fromDate + 1
      );
    } else {
      var peopleManager = new PeopleManagersHistoryDetails();
      this.newAttributepm = {
        ID: 0,
        DurationFrom: new Date(fromYear, fromMonth, fromDate + 1),
      };
      this.HREm.peopleManagersHistoryDetails.push(this.newAttributepm);
    }
    this.newAttributepm = {};
  }

  someMethodNameSM(fromDateofJoining: Date, j) {
    var todate = new Date(fromDateofJoining);
    const fromYear = todate.getFullYear();
    const fromMonth = todate.getMonth();
    const fromDate = todate.getDate();
    if (this.HREm.seniorManagersHistoryDetails[j + 1]) {
      this.HREm.seniorManagersHistoryDetails[j + 1].DurationFrom = new Date(
        fromYear,
        fromMonth,
        fromDate + 1
      );
    } else {
      var seniorManager = new SeniorManagersHistoryDetails();
      this.newAttribute = {
        ID: 0,
        DurationFrom: new Date(fromYear, fromMonth, fromDate + 1),
      };
      this.HREm.seniorManagersHistoryDetails.push(this.newAttribute);
    }
    this.newAttribute = {};
  }

  someMethodNameLoc(fromDateofJoining: Date, j) {
    var todate = new Date(fromDateofJoining);
    const fromYear = todate.getFullYear();
    const fromMonth = todate.getMonth();
    const fromDate = todate.getDate();
    if (this.HREm.employeeLocationHistories[j + 1]) {
      this.HREm.employeeLocationHistories[j + 1].StartDate = new Date(
        fromYear,
        fromMonth,
        fromDate + 1
      );
    } else {
      var loc = new EmployeeLocationHistories();
      this.newAttributeLoc = {
        ID: 0,
        StartDate: new Date(fromYear, fromMonth, fromDate + 1),
      };
      this.HREm.employeeLocationHistories.push(this.newAttributeLoc);
    }
    this.newAttributeLoc = {};
  }

  //someMethodNameDes(fromDateofJoining: Date, j) {
  //  var desgn = new EmployeeDesignationHistories();
  //  this.newAttributeDes = {};
  //  var todate = new Date(fromDateofJoining);
  //  const fromYear = todate.getFullYear();
  //  const fromMonth = todate.getMonth();
  //  const fromDate = todate.getDate();
  //  this.newAttributeDes = {
  //    ID: 0,
  //    StartDate: new Date(fromYear, fromMonth, fromDate + 1),
  //  };
  //  this.HREm.employeeDesignationHistories.push(this.newAttributeDes);
  //  this.newAttributeDes = {};
  //}

  someMethodNameMail(fromDateofJoining: Date, j) {
    var todate = new Date(fromDateofJoining);
    const fromYear = todate.getFullYear();
    const fromMonth = todate.getMonth();
    const fromDate = todate.getDate();
    if (this.HREm.employeeEmailHistories[j + 1]) {
      this.HREm.employeeEmailHistories[j + 1].StartDate = new Date(
        fromYear,
        fromMonth,
        fromDate + 1
      );
    } else {
      var mail = new EmployeeEmailHistories();
      this.newAttributeMail = {
        ID: 0,
        StartDate: new Date(fromYear, fromMonth, fromDate + 1),
      };
      this.HREm.employeeEmailHistories.push(this.newAttributeMail);
    }
    this.newAttributeMail = {};
  }


  someMethodNameDes(fromDateofJoining: Date, j) {
    this.filteredList[j + 1] = this.designationsList;
    var todate = new Date(fromDateofJoining);
    const fromYear = todate.getFullYear();
    const fromMonth = todate.getMonth();
    const fromDate = todate.getDate();
    if (this.HREm.employeeDesignationHistories[j + 1]) {
      this.HREm.employeeDesignationHistories[j + 1].StartDate = new Date(
        fromYear,
        fromMonth,
        fromDate + 1
      );
    } else {
      var des = new EmployeeDesignationHistories();
      this.newAttributeDes = {
        ID: 0,
        StartDate: new Date(fromYear, fromMonth, fromDate + 1),
      };
      this.HREm.employeeDesignationHistories.push(this.newAttributeDes);
    }
    this.newAttributeDes = {};
  }

  someMethodNameDep(fromDateofJoining: Date, j) {
    this.filteredDeptList[j + 1] = this.departmentsList;
    var todate = new Date(fromDateofJoining);
    const fromYear = todate.getFullYear();
    const fromMonth = todate.getMonth();
    const fromDate = todate.getDate();
    if (this.HREm.employeeDepartmentHistories[j + 1]) {
      this.HREm.employeeDepartmentHistories[j + 1].StartDate = new Date(
        fromYear,
        fromMonth,
        fromDate + 1
      );
    } else {
      var dep = new EmployeeDepartmentHistories();
      this.newAttributeDep = {
        ID: 0,
        StartDate: new Date(fromYear, fromMonth, fromDate + 1),
      };
      this.HREm.employeeDepartmentHistories.push(this.newAttributeDep);
    }
    this.newAttributeDep = {};
  }

  someMethodNameCad(fromDateofJoining: Date, j) {
    this.filteredCadreList[j + 1] = this.cadresList;
    var todate = new Date(fromDateofJoining);
    const fromYear = todate.getFullYear();
    const fromMonth = todate.getMonth();
    const fromDate = todate.getDate();
    if (this.HREm.employeeCadreHistories[j + 1]) {
      this.HREm.employeeCadreHistories[j + 1].StartDate = new Date(
        fromYear,
        fromMonth,
        fromDate + 1
      );
    } else {
      var cad = new EmployeeCadreHistories();
      this.newAttributeCad = {
        ID: 0,
        StartDate: new Date(fromYear, fromMonth, fromDate + 1),
      };
      this.HREm.employeeCadreHistories.push(this.newAttributeCad);
    }
    this.newAttributeCad = {};
  }
  onPeopleManagerChange(ob, j) {
    this.HREm.peopleManagersHistoryDetails[j].pmDisplayName =
      ob.option.viewValue;
    this.HREm.peopleManagersHistoryDetails[j].ManagerCode = ob.option.value;
    var empobj = this.empList.find((x) => x.EmpCode == ob.option.value);
    this.HREmp.PeopleManagerCode = ob.option.value;
    this.HREm.peopleManagersHistoryDetails[j].DesignationName =
      empobj.DesignationName;
    this.HREm.peopleManagersHistoryDetails[j].ManagerDesignationID =
      empobj.DesignationId;
  }
  deleteField(index) {
    const message = `Are you sure you want to delete?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "600px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.HREm.peopleManagersHistoryDetails.splice(index, 1);
          this.HREm.peopleManagersHistoryDetails.forEach((obj, i) => {
            if (i === index - 1) {
              obj.IsActive = true;
            } else {
              obj.IsActive = false;
            }
          });
          this.cdr.detectChanges();
        }
        if (this.HREm.peopleManagersHistoryDetails.length == 1) {
          this.HREm.peopleManagersHistoryDetails[index - 1].DurationTo = null;
        }
        if (this.HREm.peopleManagersHistoryDetails.length == index) {
          this.HREm.peopleManagersHistoryDetails[index - 1].DurationTo = null;
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }
  onSeniorManagerChange(ob, j) {
    this.HREm.seniorManagersHistoryDetails[j].smDisplayName =
      ob.option.viewValue;
    this.HREm.seniorManagersHistoryDetails[j].SeniorManagerCode =
      ob.option.value;
    var empobject = this.empList.find((x) => x.EmpCode == ob.option.value);
    this.HREmp.SeniorManagerCode = ob.option.value;
    this.HREm.seniorManagersHistoryDetails[j].DesignationName =
      empobject.DesignationName;
    this.HREm.seniorManagersHistoryDetails[j].SeniorManagerDesignationID =
      empobject.DesignationId;
  }

  deleteFieldSM(index) {
    const message = `Are you sure you want to delete?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "600px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.HREm.seniorManagersHistoryDetails.splice(index, 1);
          this.HREm.seniorManagersHistoryDetails.forEach((obj, i) => {
            if (i === index - 1) {
              obj.IsActive = true;
            } else {
              obj.IsActive = false;
            }
          });
          this.cdr.detectChanges();
        }
        if (this.HREm.seniorManagersHistoryDetails.length == 1) {
          this.HREm.seniorManagersHistoryDetails[index - 1].DurationTo = null;
        }
        if (this.HREm.seniorManagersHistoryDetails.length == index) {
          this.HREm.seniorManagersHistoryDetails[index - 1].DurationTo = null;
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  deleteFieldDes(index) {
    const message = `Are you sure you want to delete?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "600px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.HREm.employeeDesignationHistories.splice(index, 1);

          this.HREm.employeeDesignationHistories.forEach((obj, i) => {
            if (i === index - 1) {
              obj.IsActive = true;
            } else {
              obj.IsActive = false;
            }
          });
          this.cdr.detectChanges();
        }
        if (this.HREm.employeeDesignationHistories.length == 1) {
          this.HREm.employeeDesignationHistories[index - 1].EndDate = null;
        }
        if (this.HREm.employeeDesignationHistories.length == index) {
          this.HREm.employeeDesignationHistories[index - 1].EndDate = null;
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  deleteFieldLoc(index) {
    const message = `Are you sure you want to delete?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "600px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.HREm.employeeLocationHistories.splice(index, 1);

          this.HREm.employeeLocationHistories.forEach((obj, i) => {
            if (i === index - 1) {
              obj.IsActive = true;
            } else {
              obj.IsActive = false;
            }
          });
          this.cdr.detectChanges();
        }
        if (this.HREm.employeeLocationHistories.length == 1) {
          this.HREm.employeeLocationHistories[index - 1].EndDate = null;
        }
        if (this.HREm.employeeLocationHistories.length == index) {
          this.HREm.employeeLocationHistories[index - 1].EndDate = null;
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  deleteFieldDep(index) {
    const message = `Are you sure you want to delete?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "600px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.HREm.employeeDepartmentHistories.splice(index, 1);

          this.HREm.employeeDepartmentHistories.forEach((obj, i) => {
            if (i === index - 1) {
              obj.IsActive = true;
            } else {
              obj.IsActive = false;
            }
          });
          this.cdr.detectChanges();
        }
        if (this.HREm.employeeDepartmentHistories.length == 1) {
          this.HREm.employeeDepartmentHistories[index - 1].EndDate = null;
        }
        if (this.HREm.employeeDepartmentHistories.length == index) {
          this.HREm.employeeDepartmentHistories[index - 1].EndDate = null;
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  deleteFieldCad(index) {
    const message = `Are you sure you want to delete?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "600px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.HREm.employeeCadreHistories.splice(index, 1);
          this.HREm.employeeCadreHistories.forEach((obj, i) => {
            if (i === index - 1) {
              obj.IsActive = true;
            } else {
              obj.IsActive = false;
            }
          });
          this.cdr.detectChanges();
        }
        if (this.HREm.employeeCadreHistories.length == 1) {
          this.HREm.employeeCadreHistories[index - 1].EndDate = null;
        }
        if (this.HREm.employeeCadreHistories.length == index) {
          this.HREm.employeeCadreHistories[index - 1].EndDate = null;
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  deleteFieldMail(index) {
    const message = `Are you sure you want to delete?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "600px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.HREm.employeeEmailHistories.splice(index, 1);
          this.HREm.employeeEmailHistories.forEach((obj, i) => {
            if (i === index - 1) {
              obj.IsActive = true;
            } else {
              obj.IsActive = false;
            }
          });
          this.cdr.detectChanges();
        }
        if (this.HREm.employeeEmailHistories.length == 1) {
          this.HREm.employeeEmailHistories[index - 1].EndDate = null;
        }
        if (this.HREm.employeeEmailHistories.length == index) {
          this.HREm.employeeEmailHistories[index - 1].EndDate = null;
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  getExitInterviewResponses() {
    this.emp_Svc.getEmpFeedbackHistory(this.empCode)
      .subscribe(
        (data: any) => {
          this.ResponseList = data;
        });
  }


  getExitInterviewHRComments() {
    this.emp_Svc
      .getExitInterviewHistory(this.empCode)
      .subscribe((data: any) => {
        this.exitInterviewsList = data;

        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        const lwd = this.exitInterviewsList && this.exitInterviewsList.LastWorkingDay ? new Date(this.exitInterviewsList.LastWorkingDay) : null;
        if (lwd) {
          lwd.setHours(0, 0, 0, 0);
        }
        const isLwdOver = lwd && currentDate >= lwd;

        if (
          this.exitInterviewsList && this.exitInterviewsList.IsEmpFeedbackRequired && !this.exitInterviewsList.IsRejected) {
          this.isAccordion = true;
        } else if (this.exitInterviewsList && this.exitInterviewsList.IsRejected) {
          this.isAccordion = false;
        } else {
          this.isAccordion = false;
        }

        if (this.exitInterviewsList && this.exitInterviewsList.IsHRCommentsSubmitted) {
          this.isSubmitVisible = false;
          this.isCommentsDisabled = true;
        }
        else if (this.exitInterviewsList && this.exitInterviewsList.IsEmpFeedbackSubmitted) {
          this.isSubmitVisible = true;
          this.isCommentsDisabled = false;
        }
        else if (this.exitInterviewsList && isLwdOver) {
          this.isSubmitVisible = true;
          this.isCommentsDisabled = false;
        }
        else {
          this.isSubmitVisible = false;
          this.isCommentsDisabled = true;
        }
      });
  }

  fetchURl(url) {
    this.emp_Svc
      .getDownloadURL(url)
      .subscribe((data: any) => {
        window.open(data, '_blank');
      });
  }

  submitHRComments() {
    const message = "Are you sure you want to submit comments?";
    const dialogData = new ConfirmDialogModel(" ", message, "Submit");
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "500px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.isLoader = true;
          this.exitInterviewsList.EmpCode = this.empCode;
          this.exitInterviewsList.IsHRCommentsSubmitted = true;
          this.emp_Svc
            .submitExitInterviewHRComments(this.exitInterviewsList)
            .subscribe(
              (data) => {
                const message = "Submitted Successfully";
                this.toastr.success(message);
                this.isLoader = false;
                this.isSubmitVisible = false;
                this.isCommentsDisabled = true;
              },
              (error) => {
                this.error = error;
                this.isLoader = false;
                this.toastr.error("Error saving comments.");
              }
            );
        }
      },
      (error) => {
        this.isLoader = false;
        this.result = error;
      }
    );
  }
}

export class pmObj {
  pmDisplayName: string;
  pmEmpCode: number;
}
export class smObj {
  smDisplayName: string;
  smEmpCode: number;
}

export interface ResignationHSTableInterface {
  EmpCode: number;
  IndicativeLWD: string;
  LastWorkingDate: string;
  ResignationDate: string;
  ProjectManagers: string;
  ResignationType: string;
  ResignationReason: number;
  status: string;
  EmployeeComments: string;
  ManagerResignationComments: string;
  HRResignationComments: string;
  DocumentPath: string;
  DocumentName: string;
  Designation: string;
  ModifiedBy: string;
  ModifiedDate: string;
  OffboardingID: number;
}
